import { attachDialog } from '../../util/dialog_helpers.js';
import { attachEventHandlers } from '../mixins/ConfirmKoreanBrowseFontsDialog.js';

/**
 * Show the Korean Browse Fonts dialog
 *
 * @return {Promise<void>}
 */
export const showKoreanBrowseFontsDialog = async () => {
  try {
    const { dialog, dialogPromise } = await attachDialog('korean_browse_fonts_dialog');

    attachEventHandlers(dialog);
    return dialogPromise;
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};
